import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  gap: 30px;
  padding: 10px;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

export const CoursesSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PrincipalSection = styled(CoursesSection)`
  padding: 36px 24px 12px 24px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e2e7f4 0%, #e1e7fb 100%);
  position: relative;

  @media screen and (max-width: 575px) {
    padding: 36px 16px 12px 16px;
  }
`;

export const PrincipalBadge = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 8px;
  padding: 8px 18px;
  border-radius: 12px;
  background: linear-gradient(135deg, #201b4c 0%, #342a7f 100%);
  border: 5px solid #fff;
  position: absolute;
  top: -22px;

  img {
    width: 16px;
    height: 16px;
  }

  span {
    font-family: 'Work Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #ffffff;
  }
`;

export const AdditionalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  span {
    font-family: 'Work Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #757575;
    white-space: nowrap;
  }

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }
`;
